import { z } from 'zod';
export const notificationSettingsSchema = z.object({
    messages: z.boolean(),
    calls: z.boolean(),
    videos: z.boolean(),
    dating: z.boolean(),
    sound: z.boolean(),
    preview: z.boolean(),
    quietHours: z.boolean(),
    quietStartMinutes: z.number().int().min(0).max(1439),
    quietEndMinutes: z.number().int().min(0).max(1439),
    timezoneOffsetMinutes: z.number().int().min(-840).max(840)
});
export const notificationSettingsUpdateSchema = notificationSettingsSchema
    .partial()
    .refine((value) => Object.keys(value).length > 0, 'Нужно изменить хотя бы одну настройку');
export const pushSubscriptionSchema = z.object({
    endpoint: z.string().url().max(4096),
    expirationTime: z.number().int().positive().nullable().optional(),
    keys: z.object({
        p256dh: z.string().min(16).max(512),
        auth: z.string().min(8).max(256)
    })
});
export const pushSubscriptionDeleteSchema = z.object({
    endpoint: z.string().url().max(4096)
});
//# sourceMappingURL=notifications.js.map